import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFirestore } from "react-redux-firebase";
import { PageLayoutDefault } from "../../components/PageLayout";
import PageTitle from "../../components/PageTitle";
import ClientForm from "../../features/ClientForm";
import { getCollectionName, DEFAULT_FORM_DATA } from "../../schema/client";

const REDIRECT_ON_SUCCESS = "/clients";

const ClientFormNewPage = (props) => {
  const routerParams = props.match.params;
  const { id = "" } = routerParams;

  // Setup
  // -----------
  // Auth
  const { uid } = useSelector((state) => state.firebase.auth);

  // Router
  let history = useHistory();

  // Firestore
  const firestore = useFirestore();
  const COLLECTION_NAME = getCollectionName(uid);

  // Forms
  const [formData, setFormData] = useState(DEFAULT_FORM_DATA);

  // Functions
  // -----------
  const onSubmit = (data) => {
    let finalData = {
      ...formData,
      uid: uid,
      timestamp: firestore.FieldValue.serverTimestamp(),
      created: firestore.FieldValue.serverTimestamp()
    };

    let apiCall;

    if (id) {
      apiCall = firestore.collection(COLLECTION_NAME).doc(id).update(finalData);
    } else {
      apiCall = firestore.collection(COLLECTION_NAME).add(finalData);
    }

    apiCall.then(() => {
      // Redirect on success
      history.push(REDIRECT_ON_SUCCESS);
    });
  };

  // Hooks
  // -----------

  return (
    <PageLayoutDefault>
      <PageTitle parentTitle="Clients" parentLink={REDIRECT_ON_SUCCESS}>
        {id ? "Edit client" : "Add new client"}
      </PageTitle>
      <ClientForm
        formData={formData}
        setFormData={setFormData}
        onSubmit={onSubmit}
      />
    </PageLayoutDefault>
  );
};

export default ClientFormNewPage;
